import React from "react";
import Svg from "../Svg";
import { SvgProps } from "../types";

const Icon: React.FC<SvgProps> = (props) => {
  return (
    <Svg viewBox="0 0 96 96" {...props}>
      <g transform="translate(0.000000,80.000000) scale(0.100000,-0.100000)" fill="#FFFFFF" stroke="none">
        <path
          d="M335 789 c-120 -11 -231 -92 -290 -213 -34 -68 -36 -78 -36 -169 -1
-109 10 -150 56 -222 62 -97 165 -163 272 -174 34 -4 60 -4 58 -1 -2 3 27 5
63 5 52 0 78 6 116 25 80 40 142 103 181 184 34 68 36 78 36 169 1 109 -10
150 -56 222 -85 134 -218 192 -400 174z m218 -77 c76 -38 129 -92 166 -171 22
-47 26 -70 26 -141 0 -76 -4 -93 -33 -152 -38 -77 -92 -130 -171 -167 -47 -22
-70 -26 -141 -26 -71 0 -94 4 -141 26 -201 94 -269 334 -147 515 100 146 282
194 441 116z"
        />
        <path
          d="M338 635 c-161 -44 -251 -206 -205 -366 34 -115 126 -180 262 -185
79 -3 79 -3 25 7 -75 13 -154 53 -190 97 -39 47 -64 131 -56 189 15 112 118
213 216 213 27 0 30 3 30 30 0 34 -8 36 -82 15z"
        />
        <path
          d="M385 571 c-157 -27 -238 -183 -171 -327 38 -83 112 -128 228 -140 52
-5 71 -3 101 12 l36 19 -82 1 c-95 1 -160 25 -204 78 -75 88 -70 192 11 264
44 38 71 46 137 40 42 -4 51 -2 60 15 12 21 -1 37 -33 37 -9 0 -22 2 -30 4 -7
2 -31 0 -53 -3z"
        />
        <path
          d="M379 500 c-44 -13 -79 -42 -100 -81 -50 -99 6 -214 126 -259 16 -6
67 -11 114 -12 75 0 86 3 107 24 l24 23 -98 0 c-83 0 -104 3 -147 25 -66 33
-99 81 -91 135 11 86 118 128 180 70 20 -18 34 -23 52 -19 13 3 24 10 24 14 0
19 -66 69 -105 79 -49 12 -50 12 -86 1z"
        />
      </g>
    </Svg>
  );
};

export default Icon;
